<template>
  <div class="text-center">
    <v-dialog
      v-model="$store.usersStore.state.editUserModal"
      max-width="560"
      persistent
    >
      <v-card class="user-modal" elevation="0">

        <!-- Header -->
        <div class="modal-header">
          <div class="header-left">
            <div class="header-icon-wrap">
              <v-icon color="white" size="20">mdi-account-edit-outline</v-icon>
            </div>
            <div>
              <div class="modal-title">Editar Usuario</div>
              <div class="modal-subtitle">Actualiza los datos del usuario</div>
            </div>
          </div>
          <v-btn icon small @click="closeModal" class="close-btn">
            <v-icon color="rgba(255,255,255,0.7)" size="18">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <v-form ref="form" v-model="validform" class="form-wrapper">
          <div class="scroll-area">

            <!-- Avatar -->
            <div class="avatar-section">
              <div class="avatar-preview" @click="triggerFileInput">
                <img v-if="displayAvatarUrl" :src="displayAvatarUrl" alt="avatar preview" />
                <v-icon v-else size="30" color="#b0bedd">mdi-account</v-icon>
                <div class="avatar-overlay">
                  <v-icon size="16" color="white">mdi-camera-outline</v-icon>
                </div>
              </div>
              <div class="avatar-info">
                <div class="avatar-label">Imagen de perfil</div>
                <div class="avatar-actions">
                  <button type="button" class="btn-link" @click="triggerFileInput">Cambiar imagen</button>
                  <button v-if="newUserData.avatar" type="button" class="btn-link danger" @click="removeNewAvatar">Quitar selección</button>
                </div>
              </div>
              <input
                ref="avatarInput"
                type="file"
                accept=".png,.jpg,.jpeg"
                class="hidden-input"
                @change="onAvatarChange"
              />
            </div>

            <!-- Datos personales -->
            <div class="section-label">
              <v-icon size="13" color="#2D4B95" class="mr-1">mdi-account-outline</v-icon>
              Datos personales
            </div>
            <div class="field-grid">
              <div class="field-group span-2">
                <label class="field-label">Nombre</label>
                <v-text-field
                  v-model="newUserData.name"
                  placeholder="Ingrese nombre del usuario"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="requiredRule"
                  class="custom-field"
                ></v-text-field>
              </div>
              <div class="field-group span-2">
                <label class="field-label">Email</label>
                <v-text-field
                  v-model="newUserData.email"
                  outlined
                  dense
                  disabled
                  hide-details="auto"
                  :rules="emailRules"
                  class="custom-field"
                ></v-text-field>
              </div>
              <div class="field-group">
                <label class="field-label">Teléfono</label>
                <v-text-field
                  v-model="newUserData.phone"
                  placeholder="Ingrese teléfono del usuario"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="requiredRule"
                  class="custom-field"
                ></v-text-field>
              </div>
              <div class="field-group">
                <label class="field-label">Dirección</label>
                <v-text-field
                  v-model="newUserData.address"
                  placeholder="Ingrese dirección del usuario"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="requiredRule"
                  class="custom-field"
                ></v-text-field>
              </div>
            </div>

          </div>
          </v-form>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeModal">Cancelar</button>
          <button class="btn-save" :disabled="loadingData" @click="sendForm">
            <v-progress-circular v-if="loadingData" indeterminate size="15" width="2" color="white" class="mr-1"></v-progress-circular>
            <v-icon v-else size="15" color="white" class="mr-1">mdi-check</v-icon>
            Confirmar
          </button>
        </div>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {updateUser} from '@/helpers/api/user'

export default {
  name: 'EditUserModal',
  data: () => ({
    validform: true,
    newUserData: {
      user_id: null,
      name: null,
      email: null,
      phone: null,
      address: null,
      avatar: null,
    },
    existingAvatarUrl: null,
    newAvatarPreviewUrl: null,
    loadingData: false,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ],
    emailRules: [
      v => !!v || 'Email es obligatorio',
      v => /.+@.+\..+/.test(v) || 'Email debe ser válido',
    ],
  }),
  computed: {
    displayAvatarUrl(){
      return this.newAvatarPreviewUrl || this.existingAvatarUrl
    }
  },
  watch: {
    'newUserData.avatar'(file){
      if(this.newAvatarPreviewUrl){
        URL.revokeObjectURL(this.newAvatarPreviewUrl)
        this.newAvatarPreviewUrl = null
      }
      if(file){
        this.newAvatarPreviewUrl = URL.createObjectURL(file)
      }
    }
  },
  mounted(){
    this.setUserInfo()
  },
  methods: {
    setUserInfo(){
      if(this.$store.usersStore.state.selectedUserInfo){
        const info = this.$store.usersStore.state.selectedUserInfo
        this.newUserData.user_id = info.id
        this.newUserData.name = info.name
        this.newUserData.email = info.email
        this.newUserData.phone = info.info?.phone || null
        this.newUserData.address = info.info?.address || null
        this.newUserData.avatar = null
        this.existingAvatarUrl = info.info?.avatar || null
      }
    },
    triggerFileInput(){
      this.$refs.avatarInput.click()
    },
    onAvatarChange(event){
      const file = event.target.files[0]
      if(file){
        this.newUserData.avatar = file
      }
      event.target.value = ''
    },
    removeNewAvatar(){
      this.newUserData.avatar = null
    },
    closeModal(){
      this.$store.usersStore.commit('setSelectedUserInfo', null)
      this.$store.usersStore.commit('setEditUserModal', false)
      this.newUserData = {
        user_id: null,
        name: null,
        email: null,
        phone: null,
        address: null,
        avatar: null,
      }
      this.existingAvatarUrl = null
      this.validform = true
      this.loadingData = false
    },

    async sendForm(){
      if(this.$refs.form.validate()){
        this.loadingData = true

        // Build FormData with only the fields supported by backend
        const formData = new FormData()
        const baseFields = ['user_id','name','phone','address','avatar']
        baseFields.forEach((key) => {
          const val = this.newUserData[key]
          if(val !== undefined && val !== null && val !== ''){
            formData.append(key, val)
          }
        })

        const user = await updateUser(formData)
        if(user && user.code === 200){
          const data = {
            project_id: this.$store.projectsStore.state.selectedProject.id,
            start: 0,
            limit: 20
          }
          this.$store.usersStore.dispatch('getUsersList', data)
          this.closeModal()
        }

        this.loadingData = false
      }
    }
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }

.user-modal {
  border-radius: 16px !important;
  overflow: hidden;
  background: #ffffff;
  display: flex !important;
  flex-direction: column !important;
  max-height: 88vh;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px 16px;
  background: linear-gradient(135deg, #2D4B95 0%, #1a2f63 100%);
  flex-shrink: 0;
}
.header-left { display: flex; align-items: center; gap: 12px; }
.header-icon-wrap {
  width: 36px; height: 36px; border-radius: 10px;
  background: rgba(255,255,255,0.15);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.modal-title { font-size: 14px; font-weight: 600; color: #fff; line-height: 1.2; }
.modal-subtitle { font-size: 11px; color: rgba(255,255,255,0.6); margin-top: 2px; }
.close-btn { background: rgba(255,255,255,0.1) !important; border-radius: 8px !important; }

.modal-body {
  padding: 0;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.form-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
.scroll-area {
  overflow-y: auto;
  padding: 20px 22px;
  flex: 1 1 auto;
  min-height: 0;
}

.section-label {
  font-size: 11px; font-weight: 600; color: #2D4B95;
  text-transform: uppercase; letter-spacing: 0.07em;
  display: flex; align-items: center; margin-bottom: 12px;
}

/* Avatar */
.avatar-section {
  display: flex; align-items: center; gap: 14px;
  padding: 14px 15px; border-radius: 12px;
  border: 1.5px solid #e2e8f4; background: #f7f9fc;
  margin-bottom: 20px;
}
.avatar-preview {
  position: relative; width: 60px; height: 60px; border-radius: 50%;
  background: #eef2fb; border: 1.5px solid #d1d9e8;
  display: flex; align-items: center; justify-content: center;
  overflow: hidden; cursor: pointer; flex-shrink: 0;
}
.avatar-preview img { width: 100%; height: 100%; object-fit: cover; }
.avatar-overlay {
  position: absolute; inset: 0; border-radius: 50%;
  background: rgba(26,47,99,0.45);
  display: flex; align-items: center; justify-content: center;
  opacity: 0; transition: opacity 0.15s;
}
.avatar-preview:hover .avatar-overlay { opacity: 1; }
.avatar-info { display: flex; flex-direction: column; gap: 4px; }
.avatar-label { font-size: 13px; font-weight: 600; color: #2d3748; }
.avatar-actions { display: flex; align-items: center; gap: 12px; }
.btn-link {
  background: none; border: none; padding: 0; cursor: pointer;
  font-size: 12px; font-weight: 600; color: #2D4B95;
}
.btn-link:hover { text-decoration: underline; }
.btn-link.danger { color: #F4516C; }
.hidden-input { display: none; }

/* Field grid */
.field-grid {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: 14px 16px; margin-bottom: 4px;
}
.field-group { display: flex; flex-direction: column; }
.field-group.span-2 { grid-column: span 2; }
.field-label {
  font-size: 12px; font-weight: 600; color: #5a6a8a;
  margin-bottom: 6px;
}

/deep/ .custom-field .v-input__slot { border-radius: 8px !important; min-height: 40px; }
/deep/ .custom-field.v-text-field--outlined fieldset { border-color: #e2e8f4; border-width: 1.5px; }
/deep/ .custom-field.v-text-field--outlined.v-input--is-focused fieldset { border-color: #2D4B95 !important; }
/deep/ .custom-field input { font-size: 13px; color: #2d3748; }
/deep/ .custom-field .v-text-field__slot input::placeholder { color: #a4b0c9; }
/deep/ .custom-field.error--text fieldset { border-color: #F4516C !important; }
/deep/ .custom-field.v-input--is-disabled .v-input__slot { background: #f2f4f9; }

/* Footer */
.modal-footer {
  display: flex; align-items: center; justify-content: flex-end;
  gap: 8px; padding: 13px 22px;
  border-top: 1px solid #e8edf5; background: #f7f9fc;
}
.btn-cancel {
  padding: 8px 16px; border-radius: 8px;
  border: 1.5px solid #d1d9e8; background: transparent;
  font-size: 13px; font-weight: 500; color: #5a6a8a; cursor: pointer;
}
.btn-cancel:hover { background: #eef2fb; border-color: #b0bedd; }
.btn-save {
  display: flex; align-items: center;
  padding: 8px 18px; border-radius: 8px; border: none;
  background: linear-gradient(135deg, #2D4B95, #1a2f63);
  font-size: 13px; font-weight: 600; color: white;
  cursor: pointer; box-shadow: 0 3px 10px rgba(45,75,149,0.3);
}
.btn-save:hover:not(:disabled) { box-shadow: 0 5px 14px rgba(45,75,149,0.4); }
.btn-save:disabled { opacity: 0.6; cursor: not-allowed; box-shadow: none; }

@media (max-width: 600px) {
  .field-grid { grid-template-columns: 1fr; }
  .field-group.span-2 { grid-column: span 1; }
}
</style>